import Vue from 'vue'
import router from './router/'
import store from './store/'
import vuetify from '@/plugins/vuetify'
import '@/plugins/register-service-worker'
import '@/plugins/storage'
import '@/plugins/vee-validate'
import '@/assets/fonts/system-font/css/system-font.css'
import '@/assets/fonts/font-awesome/css/fontawesome-all.min.css'
import '@/assets/fonts/font-awesome/css/fontawesome-animation.min.css'
import '@/assets/theme/default.sass'
import '@/assets/theme/pandaria.css'
import '@/assets/css/fakeLoader.css'
import '@/assets/css/components-icon.css'
import '@/util/prototype'
import '@mdi/font/css/materialdesignicons.css'

import App from './App.vue'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// widget
import ApplicationList from '@/components/widget/list/List'
import BasicCard from '@/components/widget/card/BasicCard'
import BasicToolTips from '@/components/widget/toolTips/BasicToolTips'
import BulbToolTips from '@/components/widget/toolTips/BulbToolTips'
import EventToolTips from '@/components/widget/toolTips/EventToolTips'
import ReviewCheckBox from '@/components/widget/input/ReviewCheckBox'
import BtnMenu from '@/components/widget/menu/BtnMenu'
import DateRangeCard from '@/components/widget/card/DateRangeCard'
import Queue from '@/components/widget/card/Queue'
import QueueItem from '@/components/widget/card/QueueItem'
import CheckboxInput from '@/components/widget/input/CheckboxInput'
import DatePickerMenu from '@/components/widget/input/DatePickerMenu'
import TimePickerMenu from '@/components/widget/input/TimePickerMenu'
import ReviewStatusIcon from '@/components/widget/icon/ReviewStatusIcon'
import SliderInput from '@/components/widget/input/SliderInput'
import SimpleTable from '@/components/widget/table/SimpleTable'
import ValidateInput from '@/components/widget/input/ValidateInput'
// common
import LoanQueue from '@/components/panda/common/queue/LoanQueue'
import ProfileSectionDialog from '@/components/panda/common/dialog/ProfileSectionDialog'
import IndicatorPanel from '@/components/panda/common/detail/IndicatorPanel'
import ProfileSection from '@/components/panda/common/detail/ProfileSection'
import ProfileSummary from '@/components/panda/common/detail/ProfileSummary'
import QualityEvaluation from '@/components/panda/common/detail/QualityEvaluation'
import RightPanel from '@/components/panda/common/detail/RightPanel'
import TribeSummary from '@/components/panda/common/detail/TribeSummary'
import PaymentSchedule from '@/components/panda/common/detail/PaymentSchedule'
import PaymentProgress from '@/components/panda/common/detail/PaymentProgress'

// Plugin simple-uploader
import uploader from 'vue-simple-uploader'
import sweetalert2 from './plugins/sweetalert2'
import VueTheMask from 'vue-the-mask'
import underscore from 'vue-underscore'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import waterfall from 'vue-waterfall2'

Vue.component(VuePerfectScrollbar.name, VuePerfectScrollbar)
// widget
Vue.component(ApplicationList.name, ApplicationList)
Vue.component(BasicCard.name, BasicCard)
Vue.component(BasicToolTips.name, BasicToolTips)
Vue.component(BulbToolTips.name, BulbToolTips)
Vue.component(EventToolTips.name, EventToolTips)
Vue.component(ReviewCheckBox.name, ReviewCheckBox)
Vue.component(BtnMenu.name, BtnMenu)
Vue.component(DateRangeCard.name, DateRangeCard)
Vue.component(DatePickerMenu.name, DatePickerMenu)
Vue.component(TimePickerMenu.name, TimePickerMenu)
Vue.component(Queue.name, Queue)
Vue.component(QueueItem.name, QueueItem)
Vue.component(CheckboxInput.name, CheckboxInput)
Vue.component(ReviewStatusIcon.name, ReviewStatusIcon)
Vue.component(SliderInput.name, SliderInput)
Vue.component(SimpleTable.name, SimpleTable)
Vue.component(ValidateInput.name, ValidateInput)
// common
Vue.component(LoanQueue.name, LoanQueue)
Vue.component(ProfileSectionDialog.name, ProfileSectionDialog)
Vue.component(IndicatorPanel.name, IndicatorPanel)
Vue.component(ProfileSection.name, ProfileSection)
Vue.component(ProfileSummary.name, ProfileSummary)
Vue.component(QualityEvaluation.name, QualityEvaluation)
Vue.component(RightPanel.name, RightPanel)
Vue.component(TribeSummary.name, TribeSummary)
Vue.component(PaymentSchedule.name, PaymentSchedule)
Vue.component(PaymentProgress.name, PaymentProgress)

Vue.use(uploader)
Vue.use(sweetalert2)
Vue.use(VueTheMask)
Vue.use(underscore)
Vue.use(DateRangePicker)
Vue.config.productionTip = false
Vue.use(waterfall)

// Define Global event bus
const eventBus = new Vue()
Vue.prototype.$eventBus = eventBus

Vue.prototype.store = store

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
})

app.$mount('#app')
